(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("featured-collections-carousel").forEach((carousel) => {
    const eagerLoad = (cell) => {
      if (!cell) return;
      cell.querySelectorAll("img").forEach((img) => {
        img.removeAttribute("loading");
        img.loading = "eager";
      });
      const list = cell.querySelector("product-list");
      if (list && typeof list.reveal === "function") {
        list.reveal();
      }
    };
    carousel.addEventListener("carousel:change", (event) => eagerLoad(event.detail.cell));
    carousel.addEventListener("carousel:settle", (event) => eagerLoad(event.detail.cell));
    eagerLoad(carousel.querySelector(".is-selected"));
  });

  } catch(e) { console.error(e); }
})();
})();
